<template>
  <section v-if="hasPermission" class="rounded-2xl border border-slate-200/60 bg-white p-6 shadow-sm">
    <div class="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
      <div class="min-w-0">
        <div class="flex items-center gap-2">
          <div class="h-6 w-1.5 rounded-full bg-gradient-to-b from-sky-500 to-emerald-500"></div>
          <h3 class="text-base font-semibold text-slate-900">数据概览</h3>
        </div>
        <p class="mt-1 text-xs text-slate-500">
          <span>{{ rangeLabel }}统计</span>
          <span v-if="lastUpdatedAt"> · {{ lastUpdatedAt }} 更新</span>
        </p>
      </div>

      <div class="flex flex-wrap items-center gap-2">
        <div class="flex rounded-lg border border-slate-200 bg-slate-50 p-1">
          <button
            v-for="range in DASHBOARD_STATISTICS_RANGES"
            :key="range.value"
            type="button"
            class="rounded-md px-3 py-1.5 text-xs font-medium transition-colors duration-200"
            :class="selectedRange === range.value ? 'bg-white text-primary-700 shadow-sm' : 'text-slate-500 hover:text-slate-800'"
            @click="changeRange(range.value)"
          >
            {{ range.label }}
          </button>
        </div>
        <button
          type="button"
          class="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-slate-200 text-slate-500 transition-colors duration-200 hover:border-primary-200 hover:bg-primary-50 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-60"
          :disabled="loading"
          title="刷新统计"
          @click="loadStatistics"
        >
          <ArrowPathIcon class="h-4 w-4" :class="{ 'animate-spin': loading }" />
        </button>
      </div>
    </div>

    <div v-if="allVisibleFailed" class="mt-4 rounded-xl border border-dashed border-slate-200 bg-slate-50 p-5 text-center text-sm text-slate-500">
      统计数据暂时不可用
    </div>

    <div v-else class="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5">
      <StatisticMetricCard
        v-for="metric in metricCards"
        :key="metric.key"
        :metric="metric"
      />
    </div>
  </section>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { ArrowPathIcon } from '@heroicons/vue/24/outline'
import StatisticMetricCard from './StatisticMetricCard.vue'
import { useDashboardStatistics } from '../composables/useDashboardStatistics'
import { DASHBOARD_STATISTICS_RANGES } from '../utils/statisticsFormat'

const {
  selectedRange,
  loading,
  lastUpdatedAt,
  metricCards,
  hasPermission,
  allVisibleFailed,
  loadStatistics
} = useDashboardStatistics()

const rangeLabel = computed(() => {
  return DASHBOARD_STATISTICS_RANGES.find(item => item.value === selectedRange.value)?.label || '近7天'
})

function changeRange(value) {
  if (selectedRange.value === value) return
  selectedRange.value = value
  loadStatistics()
}

onMounted(() => {
  loadStatistics()
})
</script>
